import { render, staticRenderFns } from "./Work.vue?vue&type=template&id=47150a1c&scoped=true&"
import script from "./Work.vue?vue&type=script&lang=js&"
export * from "./Work.vue?vue&type=script&lang=js&"
import style0 from "./Work.vue?vue&type=style&index=0&id=47150a1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47150a1c",
  null
  
)

export default component.exports